import PengajuanPettyCashApi from '../__PengajuanPettyCashApi__';

export const getAkumulasiProyek = async (params) => {
  return PengajuanPettyCashApi.getAkumulasi(params)
    .then((res) => res.data.data ?? {})
    .catch(({ response }) =>
      window.alert(response?.data?.message ?? 'Gagal memuat akumulasi')
    );
};
